"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _linkIcon = _interopRequireDefault(require("./assets/linkIcon"));

var _UserAvatar = _interopRequireDefault(require("@insided/deprecated-preact-components/User/UserAvatar"));

var _UserName = _interopRequireDefault(require("@insided/deprecated-preact-components/User/UserName"));

var _buttonControl = _interopRequireDefault(require("@insided/deprecated-preact-components/button-control"));

var _axios = _interopRequireDefault(require("axios"));

var qs = _interopRequireWildcard(require("qs"));

var _message = _interopRequireDefault(require("@insided/deprecated-preact-components/design-system-components/message"));

var _Loader = _interopRequireDefault(require("../../ui-components/Loader"));

var _Modal = require("@insided/shared/uikit/Modal");

var _EmptyPage = _interopRequireDefault(require("@insided/deprecated-preact-components/empty-page/EmptyPage"));

var _Button = _interopRequireDefault(require("@insided/shared/uikit/Button"));

var _globals = _interopRequireDefault(require("@insided/shared/utils/globals"));

var _overview = _interopRequireDefault(require("../../overview"));

var _common = require("@insided/deprecated-control/Event/create-event/common");

var _StatusCircle = _interopRequireDefault(require("@insided/deprecated-control/ui-components/StatusCircle"));

var _EventDateFormatter = _interopRequireDefault(require("@insided/deprecated-preact-components/Event/EventDateFormatter"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function getRequestParams(_ref) {
  var pagination = _ref.pagination;
  return {
    page: pagination.page,
    size: pagination.pageSize
  };
}

function fetchEvents(_x) {
  return _fetchEvents.apply(this, arguments);
}

function _fetchEvents() {
  _fetchEvents = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(options) {
    var queryParams, response;
    return _regenerator.default.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            queryParams = getRequestParams({
              pagination: options.pagination
            });
            _context3.next = 3;
            return _axios.default.get('/event/events', {
              params: queryParams,
              paramsSerializer: function paramsSerializer(params) {
                return qs.stringify(params, {
                  arrayFormat: 'brackets'
                });
              }
            });

          case 3:
            response = _context3.sent;
            return _context3.abrupt("return", {
              data: response.data.events,
              total: response.data.total
            });

          case 5:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _fetchEvents.apply(this, arguments);
}

var EventOverview = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(EventOverview, _Component);

  var _super = _createSuper(EventOverview);

  function EventOverview() {
    var _this;

    (0, _classCallCheck2.default)(this, EventOverview);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      isLoading: false,
      showDeleteConfirmationModal: false,
      backendResponse: {
        messageType: null,
        messageText: ''
      },
      needOverviewRefresh: false
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onOverviewRefresh", function () {
      _this.setState({
        needOverviewRefresh: false
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "titleColumn", {
      header: 'Title',
      accessor: 'title',
      cell: function cell(event) {
        return (0, _preact.h)("span", {
          className: "event-link"
        }, (0, _preact.h)("a", {
          href: (0, _absoluteUrlRuntime.resolveUrl)("/event/".concat(event.eventId)),
          className: "qa-title-link",
          "data-track-type": "click",
          "data-element-name": "events page link"
        }, event.title), ' ', event.status !== 'draft' && (0, _preact.h)("a", {
          target: "_blank",
          rel: "noreferrer",
          href: (0, _absoluteUrlRuntime.resolveUrl)(event.destinationUrl),
          className: "qa-destination-link",
          "data-track-type": "click",
          "data-element-name": "events destination page link"
        }, (0, _preact.h)(_linkIcon.default, null)));
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "eventTypeColumn", {
      header: 'Event type',
      accessor: 'type'
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "statusColumn", {
      header: 'Status',
      accessor: 'status',
      cell: function cell(event) {
        var isEventPassed = _EventDateFormatter.default.isEventPassed(event.endDate, event.endTime, event.timezone);

        var metadataPublished = event.status === 'published' ? 'Published' : 'Draft';
        var metadata = event.status === 'published' && isEventPassed ? 'Past' : metadataPublished;
        var statusVariant = event.status === 'published' && isEventPassed ? 'past' : event.status;
        return (0, _preact.h)("div", {
          className: "event-status"
        }, (0, _preact.h)(_StatusCircle.default, {
          variant: statusVariant
        }), (0, _preact.h)("p", {
          className: "event-status-text"
        }, metadata));
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "eventStartDateColumn", {
      header: 'Event start date',
      accessor: 'startDate',
      cell: function cell(event) {
        var dateStr = '';
        var customClasses = '';

        if (event.startDate && event.startTime) {
          var startDate = event.startDate.split('-').join('/');
          var startTime = event.startTime && event.timezone ? " ".concat(event.startTime.hours, ":").concat(event.startTime.minutes, " ").concat(event.startTime.period, " ").concat(event.timezone.offset) : '';
          var date = new Date("".concat(startDate).concat(startTime));
          customClasses = date < new Date() ? 'past-event' : 'upcoming-event';
          dateStr = date.toLocaleString([], {
            hour12: false
          });
        }

        return (0, _preact.h)("span", {
          className: "".concat(customClasses, " qa-starts-at")
        }, dateStr);
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "eventCreatorColumn", {
      header: 'Event creator',
      accessor: 'author',
      cell: function cell(event) {
        return event.author ? (0, _preact.h)("span", {
          className: "event-author qa-event-author-".concat(event.eventId)
        }, (0, _preact.h)(_UserAvatar.default, {
          user: event.author
        }), " ", (0, _preact.h)(_UserName.default, {
          user: event.author
        })) : null;
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "rsvpColumn", {
      header: 'RSVP',
      accessor: 'rsvp'
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "actionsColumn", {
      header: 'Actions',
      accessor: 'delete',
      cell: function cell(event) {
        return (0, _preact.h)("div", null, (0, _preact.h)(_buttonControl.default, {
          newStyle: true,
          title: "Duplicate",
          variant: "secondary",
          class: "qa-event-duplicate-".concat(event.eventId),
          onClick: function onClick() {
            _this.duplicateEvent(event);
          }
        }), (0, _preact.h)(_buttonControl.default, {
          newStyle: true,
          title: "Delete",
          variant: "warning",
          class: "qa-event-delete-".concat(event.eventId),
          onClick: function onClick() {
            return _this.setState({
              showDeleteConfirmationModal: true,
              eventToDelete: event
            });
          },
          "data-track-type": "click",
          "data-element-name": "Delete button"
        }));
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "model", [_this.titleColumn, _this.eventTypeColumn, _this.statusColumn, _this.eventStartDateColumn, _this.eventCreatorColumn, _this.rsvpColumn, _this.actionsColumn]);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "dataSource", fetchEvents);
    return _this;
  }

  (0, _createClass2.default)(EventOverview, [{
    key: "deleteEvent",
    value: function () {
      var _deleteEvent = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        var eventToDelete;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                eventToDelete = this.state.eventToDelete;

                if (eventToDelete) {
                  _context.next = 4;
                  break;
                }

                this.setState({
                  backendResponse: {
                    messageType: 'error',
                    messageText: 'Failed to delete an event.'
                  }
                });
                return _context.abrupt("return");

              case 4:
                _context.prev = 4;
                this.setState({
                  isLoading: true
                });
                _context.next = 8;
                return _axios.default.delete("/event/".concat(eventToDelete.eventId), {
                  data: {
                    csrfToken: this.props.csrfToken
                  },
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Requested-With': 'XMLHttpRequest'
                  }
                });

              case 8:
                this.setState({
                  needOverviewRefresh: true
                });
                _context.next = 14;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context["catch"](4);
                this.setState({
                  backendResponse: {
                    messageType: 'error',
                    messageText: 'Failed to delete an event.'
                  }
                });

              case 14:
                this.setState({
                  isLoading: false
                });

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[4, 11]]);
      }));

      function deleteEvent() {
        return _deleteEvent.apply(this, arguments);
      }

      return deleteEvent;
    }()
  }, {
    key: "duplicateEvent",
    value: function () {
      var _duplicateEvent = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(event) {
        var res, eventId;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                this.setState({
                  isLoading: true
                });
                _context2.next = 4;
                return _axios.default.post("/content/publish/event", (0, _common.getDuplicateData)(_objectSpread(_objectSpread({}, event), {}, {
                  title: "".concat(event.title, " (copy)"),
                  status: 'draft'
                })));

              case 4:
                res = _context2.sent;
                eventId = res.data.id;
                this.setState({
                  backendResponse: {
                    messageType: 'success',
                    messageText: (0, _preact.h)("div", null, "Your event has been successfully duplicated. Click", ' ', (0, _preact.h)("a", {
                      className: ".qa-newEvent",
                      href: (0, _absoluteUrlRuntime.resolveUrl)("/event/".concat(eventId))
                    }, "here"), ' ', "to edit it.")
                  },
                  needOverviewRefresh: true
                });
                _context2.next = 12;
                break;

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2["catch"](0);
                this.setState({
                  backendResponse: {
                    messageType: 'error',
                    messageText: 'Failed to duplicate an event.'
                  }
                });

              case 12:
                this.setState({
                  isLoading: false
                });

              case 13:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 9]]);
      }));

      function duplicateEvent(_x2) {
        return _duplicateEvent.apply(this, arguments);
      }

      return duplicateEvent;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$state = this.state,
          backendResponse = _this$state.backendResponse,
          isLoading = _this$state.isLoading,
          showDeleteConfirmationModal = _this$state.showDeleteConfirmationModal,
          needOverviewRefresh = _this$state.needOverviewRefresh;
      var pagination = {
        page: 1,
        pageSize: 25,
        pageSizes: [10, 25, 50, 100]
      };
      return (0, _preact.h)("div", {
        className: "event-overview qa-event-overview"
      }, (0, _preact.h)("div", {
        className: "control-header"
      }, (0, _preact.h)("h2", null, "Events"), (0, _preact.h)("div", {
        className: "control-header__buttons"
      }, (0, _preact.h)("a", {
        href: (0, _absoluteUrlRuntime.resolveUrl)("/settings/eventTypes"),
        "data-track-type": "click",
        "data-element-name": "Manage Event Types link"
      }, (0, _preact.h)(_Button.default, {
        type: "button",
        "data-track-type": "click",
        "data-element-name": "Manage Event Types button"
      }, "Manage Event Types")), (0, _preact.h)("a", {
        href: (0, _absoluteUrlRuntime.resolveUrl)("/content/new/event"),
        "data-track-type": "click",
        "data-element-name": "Create New Event link"
      }, (0, _preact.h)(_Button.default, {
        type: "button",
        variant: "primary",
        "data-track-type": "click",
        "data-element-name": "Create New Event button"
      }, "Create New Event")))), isLoading && (0, _preact.h)(_Loader.default, null), (0, _preact.h)("div", {
        className: "control-body"
      }, backendResponse.messageType !== null ? (0, _preact.h)(_message.default, {
        isControl: true,
        variant: backendResponse.messageType,
        timer: 5000,
        onDismiss: function onDismiss() {
          _this2.setState({
            backendResponse: {
              messageType: null,
              messageText: ''
            }
          });
        }
      }, backendResponse.messageText) : null, (0, _preact.h)(_Modal.Modal, {
        isOpen: showDeleteConfirmationModal,
        size: "medium"
      }, (0, _preact.h)(_Modal.ModalHeader, {
        title: "Delete event?",
        onClose: function onClose() {
          return _this2.setState({
            showDeleteConfirmationModal: false
          });
        }
      }), (0, _preact.h)(_Modal.ModalBody, null, " If you delete an event, it's gone for good."), (0, _preact.h)(_Modal.ModalFooter, null, (0, _preact.h)(_buttonControl.default, {
        title: "Delete",
        newStyle: true,
        class: "qa-confirm-delete",
        variant: "warning",
        onClick: function onClick() {
          return _this2.setState({
            showDeleteConfirmationModal: false
          }, function () {
            _this2.deleteEvent();
          });
        },
        "data-track-type": "click",
        "data-element-name": "Delete button"
      }), (0, _preact.h)(_buttonControl.default, {
        newStyle: true,
        title: "Cancel",
        onClick: function onClick() {
          return _this2.setState({
            showDeleteConfirmationModal: false
          });
        },
        "data-track-type": "click",
        "data-element-name": "Cancel button"
      }))), (0, _preact.h)(_overview.default, {
        type: "EventsOverview",
        headerTitle: "Events",
        rowId: "event_id",
        model: this.model,
        withActionElements: false,
        withHeader: false,
        showFilters: false,
        withPagination: pagination,
        entity: "events",
        dataSource: this.dataSource,
        EmptyStateComponent: (0, _preact.h)("div", null, (0, _preact.h)(_EmptyPage.default, {
          img_src: "".concat((0, _globals.default)('defaultCdn'), "/images/empty_page.png"),
          header: "There are no events yet",
          text: 'Seems like no one on your team has created an event. \n Start now by creating one.',
          button: {
            link: '/content/new/event',
            text: 'Create New Event'
          }
        })),
        withMultiSelect: false,
        headerButtons: [(0, _preact.h)("a", {
          href: (0, _absoluteUrlRuntime.resolveUrl)("/settings/eventTypes"),
          key: "types",
          "data-track-type": "click",
          "data-element-name": "Manage Event Types link"
        }, (0, _preact.h)(_Button.default, {
          type: "button"
        }, "Manage Event Types")), (0, _preact.h)("a", {
          href: (0, _absoluteUrlRuntime.resolveUrl)("/content/new/event"),
          key: "new",
          "data-track-type": "click",
          "data-element-name": "Create New Event link"
        }, (0, _preact.h)(_Button.default, {
          type: "button",
          variant: "primary"
        }, "Create New Event"))],
        needOverviewRefresh: needOverviewRefresh,
        onOverviewRefresh: this.onOverviewRefresh
      })));
    }
  }]);
  return EventOverview;
}(_preact.Component);

var _default = EventOverview;
exports.default = _default;